import {useDispatch, useSelector} from 'react-redux'
import {
  getAllUserDetails,
  getIsDefaultRegion,
} from '../../../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useEffect} from 'react'
import {
  getSidebarRedDotData,
  InboxSmsBadge,
  ConversationBadge,
} from '../../../../app/pages/UserPages/inbox/InboxSlice/InboxSlice'
import {useLocation} from 'react-router-dom'
import {ENV} from '../../../../app/Utils/_helpers/EnvHelper'

import {
  Capture as CaptureV1,
  Engagement as EngagementV1,
  Convert as ConvertV1,
  System as SystemV1,
  backEndMenu,
  Campaign,
  CampaignRegion,
  More,
  MoreRegion,
  Tools,
  ToolsRegion,
  WalletCard,
  WalletCardNotActivate,
} from '../../../../app/Utils/Constant/ArrayOfSideNav'

import {
  Capture as CaptureV2,
  Engagement as EngagementV2,
  Convert as ConvertV2,
  System as SystemV2,
  Campaign as CampaignV2,
  More as MoreV2,
  Tools as ToolsV2,
  WalletCard as WalletCardV2,
  WalletCardNotActivate as WalletCardNotActivateV2,
  LeadManagement,
} from '../../../../app/Utils/Constant/ArrayOfSideNavV2'

import {
  Capture as CaptureV3,
  Engagement as EngagementV3,
  Convert as ConvertV3,
  System as SystemV3,
  More as MoreV3,
  Campaign as CampaignV3,
  WalletCard as WalletCardV3,
  Tools as ToolsV3,
  WalletCardNotActivate as WalletCardNotActivateV3,
  LeadManagement as LeadManagementV3,
} from '../../../../app/Utils/Constant/ArrayOfSideNavV3'

import {GLOBAL_SETTINGS_TYPE} from '../../../../app/Utils/Constant/ConstantForWebsite'

const navigationMap = {
  navigationV1: {
    Capture: CaptureV1,
    Engagement: EngagementV1,
    Convert: ConvertV1,
    System: SystemV1,
    LeadManagement,
    Campaign,
    CampaignRegion,
    More,
    MoreRegion,
    Tools,
    ToolsRegion,
    WalletCard,
    WalletCardNotActivate,
    backEndMenu,
  },
  navigationV2: {
    Capture: CaptureV2,
    Engagement: EngagementV2,
    Convert: ConvertV2,
    System: SystemV2,
    LeadManagement,
    Campaign: CampaignV2,
    CampaignRegion,
    More: MoreV2,
    MoreRegion,
    Tools: ToolsV2,
    ToolsRegion,
    WalletCard: WalletCardV2,
    WalletCardNotActivate: WalletCardNotActivateV2,
    backEndMenu,
  },
  navigationV3: {
    Capture: CaptureV3,
    Engagement: EngagementV3,
    Convert: ConvertV3,
    System: SystemV3,
    MoreRegion,
    ToolsRegion,
    WalletCardNotActivate: WalletCardNotActivateV3,
    backEndMenu,
    LeadManagement: LeadManagementV3,
    Tools: ToolsV3,
    More: MoreV3,
    Campaign: CampaignV3,
    WalletCard: WalletCardV3,
    CampaignRegion,
  },
}

const useAsideMenuMainHooks = () => {
  const dispatch = useDispatch()
  const userData: any = useSelector(getAllUserDetails)
  const isDefaultRegion: any = useSelector(getIsDefaultRegion)
  const isAdmin = localStorage.getItem('isAdmin')

  const {pathname} = useLocation()

  const sidebarRedDotData = useSelector(getSidebarRedDotData)
  const newNavigation = userData?.globalSetting?.find(
    (item: string) =>
      item === GLOBAL_SETTINGS_TYPE.NEW_NAVIGATION ||
      item === GLOBAL_SETTINGS_TYPE.NEW_NAVIGATION_V3
  )
  const isNewInboxEnabled = userData?.globalSetting?.includes(GLOBAL_SETTINGS_TYPE.NEW_INBOX)

  const sys = useSelector((state: any) => state?.notification?.system)
  const port = useSelector((state: any) => state?.notification?.portal)
  const notification = +sys?.length + +port?.length

  const param = document.location.host
  const isCellcast = param === ENV().REACT_APP_CELLCAST

  const getNavigation = () => {
    const key: keyof typeof navigationMap = newNavigation ? newNavigation : 'navigationV1'
    return navigationMap[key] || navigationMap['navigationV1']
  }

  useEffect(() => {
    if (!(isAdmin === 'true')) {
      // Use conversation badge when new inbox is enabled, otherwise use legacy inbox badge
      if (isNewInboxEnabled) {
        dispatch(ConversationBadge())
      } else {
        dispatch(InboxSmsBadge())
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isNewInboxEnabled])

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null
    const defaultTitle = isCellcast ? 'Cellcast' : 'My Message Centre'

    const hasUnread = sidebarRedDotData?.unread > 0
    const hasNotification = notification > 0

    if (hasUnread) {
      const titles = ['- New Message', '']
      let current = 0

      intervalId = setInterval(() => {
        document.title = `${defaultTitle} ${titles[current]}`
        current = (current + 1) % titles.length
      }, 5000)
    } else if (hasNotification) {
      // Alternate between "Notification" and default title
      const titles = ['- Notification', '']
      let current = 0

      intervalId = setInterval(() => {
        const suffix = titles[current]
        document.title = suffix ? `${defaultTitle} ${suffix}` : defaultTitle
        current = (current + 1) % titles.length
      }, 5000)
    } else {
      // No notifications or unread messages
      document.title = defaultTitle
    }

    return () => {
      if (intervalId) clearInterval(intervalId)
      document.title = defaultTitle
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidebarRedDotData?.unread, notification])

  return {
    userData,
    isDefaultRegion,
    isAdmin,
    getNavigation,
    newNavigation,
  }
}

export default useAsideMenuMainHooks
